var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flatpickr',{staticClass:"date-picker",attrs:{"config":{
    mode: 'range',
    maxDate: 'today',
    onChange: _vm.onDateRangeChange
},"placeholder":"Select Date","value":_vm.value},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})}
var staticRenderFns = []

export { render, staticRenderFns }